import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import UltimatePagination from 'react-ultimate-pagination-bootstrap-3';

import { retrieveRunRecords, updateRecordPage } from '../store/actions/run_records';
import ScrollableRecordsTable from './scrollable_records_table';
import FixedRecordsTable from './fixed_records_table';
import { getMeta } from '../store/run_records_selectors';

export function RecordsTable({
  currentPage,
  retrieveRunRecords,
  totalPages,
  onUpdatePage
}) {

  const handleUpdatePage = (page) => {
    if (page >= 1 && page <= totalPages) {
      onUpdatePage(page);
      retrieveRunRecords();
    }
  };

  return (
    <React.Fragment>
      <div className="table-container">
        <FixedRecordsTable />
        <ScrollableRecordsTable />
      </div>
      <UltimatePagination
        currentPage={currentPage}
        totalPages={totalPages}
        onChange={handleUpdatePage}
      />
    </React.Fragment>
  );
}

RecordsTable.propTypes = {
  currentPage: PropTypes.number.isRequired,
  retrieveRunRecords: PropTypes.func.isRequired,
  totalPages: PropTypes.number.isRequired,
  onUpdatePage: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  ...getMeta(state),
});

const mapDispatchToProps = {
  onUpdatePage: updateRecordPage,
  retrieveRunRecords
};

export default connect(mapStateToProps, mapDispatchToProps)(RecordsTable);
